import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLinkedinBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={19} fill="none" {...props}>
    <path
      fill="#000"
      d="M15.333 0H4.48A3.876 3.876 0 0 0 .604 3.876v10.852a3.877 3.877 0 0 0 3.877 3.877h10.852a3.876 3.876 0 0 0 3.876-3.877V3.876A3.876 3.876 0 0 0 15.333 0ZM6.806 14.728H4.481V6.202h2.325v8.526Zm-1.162-9.51a1.363 1.363 0 0 1-1.358-1.367c0-.755.609-1.367 1.358-1.367C6.392 2.484 7 3.096 7 3.85c0 .756-.607 1.368-1.356 1.368Zm10.465 9.51h-2.326v-4.344c0-2.61-3.101-2.413-3.101 0v4.344H8.356V6.202h2.326v1.367c1.082-2.004 5.427-2.152 5.427 1.92v5.24Z"
    />
  </svg>
);
export default SvgLinkedinBlack;
